import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var trainingTypeRes;
export const trainingTypeTodo = createAsyncThunk('trainingType', async (date) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/training_types_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return trainingTypeRes = res.data
    } catch (error) {
        return trainingTypeRes = error.response.data
    }
})


const trainingTypeSlice = createSlice({
    name: 'trainingType',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(trainingTypeTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('trainingType', state.data)
            }
        });
        builder.addCase(trainingTypeTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default trainingTypeSlice.reducer; 